import React from 'react';

const Radio = ({ ...rest }) => <input {...rest} type="radio" />;

export default Radio;
